import { MatchSliceState } from '../matchSliceTypes';
import MatchEvent from '../../../interfaces/matchEvent';
import { MatchEventType } from '../../../enums/matchEventType';

export default function (state: MatchSliceState, matchEvent: MatchEvent, personId?: number): void {
  const { homeTeam, awayTeam } = state.match;

  if (
    matchEvent.matchEventTypeId === MatchEventType.RED_CARD ||
    matchEvent.matchEventTypeId === MatchEventType.SECOND_YELLOW_CARD
  ) {
    if (!matchEvent.team) throw 'No team attached to goal matchEvent (3)';
    if (matchEvent.team.id === homeTeam.id) {
      homeTeam.persons.forEach((personInMatch) => {
        if (
          (matchEvent.person && personInMatch.personId === matchEvent.person.id) ||
          personInMatch.personId === personId
        ) {
          personInMatch.currentlyOnTheField = true;
        }
      });
    } else if (matchEvent.team.id === awayTeam.id) {
      awayTeam.persons.forEach((personInMatch) => {
        if (
          (matchEvent.person && personInMatch.personId === matchEvent.person.id) ||
          personInMatch.personId === personId
        ) {
          personInMatch.currentlyOnTheField = true;
        }
      });
    }
  }
}
